import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import createSagaMiddleware from 'redux-saga';

import { composeWithDevTools } from '@redux-devtools/extension';

import rootReducer, { history } from './rootReducer';
import rootSaga from './rootSaga';
import { environment } from 'environments/environment';

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, routerMiddleware(history)];

const persistConfig = {
  key: 'apfSessionContext',
  storage: storageSession,
  whitelist: ['auth', 'context'],
  debug: environment.debug,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const storeEnhancer =
  environment.devtoolsEnabled?.toLowerCase() === 'true'
    ? composeWithDevTools(applyMiddleware(...middlewares))
    : compose(applyMiddleware(...middlewares));

const store = createStore(persistedReducer, storeEnhancer);

const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export { store, persistor };
